"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var Paragraph = function Paragraph(_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["children"]);
  return (// eslint-disable-next-line react/jsx-props-no-spreading
    _react["default"].createElement(_Text["default"], (0, _extends2["default"])({
      as: "p",
      fontSize: 4,
      mb: 3
    }, props), children)
  );
};

var _default = Paragraph;
exports["default"] = _default;